/**
 * Loom tutorial video URLs for Dashboard Overview and page tutorials.
 * Invoice Simple uses the base key (e.g. reporting).
 * Joist uses the same key with a Joist suffix (e.g. reportingJoist).
 */
export const pageTutorialVideos = {
  reporting: "https://www.loom.com/share/12580d7c99c54e1d88493c3f7a5d1866",
  reportingJoist: "https://www.loom.com/share/b76defdb2cd94cb38e4b0e5dd7f1a646",
  billing: "https://www.loom.com/share/dc295459a3f94e06b6b2b518fedc3f3c",
  billingJoist: "https://www.loom.com/share/58c4bcba16a04bf4b48640f30b90e025",
  supportTickets: "https://www.loom.com/share/1bbfc8be5f3f4531bb1d9b2984cc10f6",
  supportTicketsJoist: "https://www.loom.com/share/4bf42cf773d44cff9742e975b3da72e9",
  manageUsers: "https://www.loom.com/share/1b5b5c0848574064b5939f603d657bb3",
  manageUsersJoist: "https://www.loom.com/share/7d0304e7d874418b979b8fcc6a87fc18",
  profile: "https://www.loom.com/share/ab4035f3b29d40e7b498aae14a96cd4b",
  profileJoist: "https://www.loom.com/share/4195f75c07484ea6b6523a58817920d9",
};

const resolvePageTutorialVideoKey = (videoKey, plgAccountType) => {
  const normalized = String(plgAccountType || "").trim().toLowerCase();

  if (normalized === "joist") {
    const joistKey = `${videoKey}Joist`;
    if (pageTutorialVideos[joistKey]) {
      return joistKey;
    }
  }

  return videoKey;
};

export const getPageTutorialVideoUrl = (videoKey, plgAccountType) => {
  const resolvedKey = resolvePageTutorialVideoKey(videoKey, plgAccountType);
  return pageTutorialVideos[resolvedKey] || "";
};

export const getDashboardOverviewVideoUrl = getPageTutorialVideoUrl;

const LOOM_ID_PATTERN = /^[a-f0-9]{32}$/i;

const getLoomVideoId = (urlOrId) => {
  if (!urlOrId) return "";
  const trimmed = String(urlOrId).trim();
  const match = trimmed.match(/loom\.com\/(?:embed|share)\/([a-f0-9]{32})/i);
  if (match) return match[1];
  if (LOOM_ID_PATTERN.test(trimmed)) return trimmed;
  return "";
};

export const getLoomEmbedUrl = (urlOrId, { autoplay = false } = {}) => {
  const videoId = getLoomVideoId(urlOrId);
  if (!videoId) return "";

  const params = new URLSearchParams({
    hide_owner: "true",
    hide_share: "true",
    hide_title: "true",
    hideEmbedTopBar: "true",
  });

  if (autoplay) {
    params.set("autoplay", "1");
  }

  return `https://www.loom.com/embed/${videoId}?${params.toString()}`;
};

export const getLoomThumbnailUrl = (urlOrId) => {
  const videoId = getLoomVideoId(urlOrId);
  if (!videoId) return "";
  return `https://cdn.loom.com/sessions/thumbnails/${videoId}-00001.jpg`;
};

const getLoomShareUrl = (urlOrId) => {
  const videoId = getLoomVideoId(urlOrId);
  if (!videoId) return "";
  if (/loom\.com\/(?:embed|share)\//i.test(String(urlOrId))) {
    return String(urlOrId).trim();
  }
  return `https://www.loom.com/share/${videoId}`;
};

export const fetchLoomThumbnailUrl = async (urlOrId) => {
  const shareUrl = getLoomShareUrl(urlOrId);
  if (!shareUrl) return "";

  try {
    const response = await fetch(
      `https://www.loom.com/v1/oembed?url=${encodeURIComponent(shareUrl)}`
    );

    if (!response.ok) {
      return "";
    }

    const data = await response.json();
    return data?.thumbnail_url || "";
  } catch (error) {
    return "";
  }
};
